export const bannersEndpoint = '/v2/banners/';
export const bannersListendpoint = '/v2/banners/home-list';
